const fishRouter = [
    {
        path: "list-fish",
        name: "fish",
        component: () => import("@/views/admin/fish"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-fish/add",
        name: "addFish",
        component: () => import("@/views/admin/fish/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-fish/edit/:id",
        name: "editFish",
        component: () => import("@/views/admin/fish/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
];
export default fishRouter;